import { ContentItemType } from './ContentItemType';
import { Mapper, ReadOnly } from 'module/Common';
import { Localized } from 'module/Model/Localized';

export type ContentRichTextTwoCols = ReadOnly<ContentRichTextTwoCols.Shape>;

export namespace ContentRichTextTwoCols {
  export interface Shape {
    type: ContentItemType;
    left: Localized<string>;
    right: Localized<string>;
    fullWidth: boolean;
  }

  const create = (input: ContentRichTextTwoCols) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(ContentItemType.RichTextTwoCols),
      fr: Mapper.schema({
        left: Mapper.str,
        right: Mapper.str,
      }),
      en: Mapper.schema({
        left: Mapper.str,
        right: Mapper.str,
      }),
      full_width: Mapper.bool,
    },
    ({ fr, en, full_width, acf_fc_layout }) =>
      create({
        left: Localized.create(fr.left, en.left),
        right: Localized.create(fr.right, en.right),
        fullWidth: full_width,
        type: acf_fc_layout,
      })
  );

  export const getLeftContent = (model: ContentRichTextTwoCols): Localized<string> => model.left;
  export const getRightContent = (model: ContentRichTextTwoCols): Localized<string> => model.right;
  export const isFullWidth = (model: ContentRichTextTwoCols): boolean => model.fullWidth;
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/ContentRichTextTwoCols.ts